import { logDetailed } from "../../helpers/utils";
import PatientExamMultiviewContext from "../../imageBrowserContext/PatientExamMultiviewContext";
import { getsortedImages } from "../../helpers/utils.js"

export const openMultiview = ({ commit, getters, dispatch }) => {
  logDetailed("actions", "openMultiview", "execution-time", "beforeLoad");
  let beforeLoad = Date.now();
  window.beforeLoadMultiview = beforeLoad;
  return dispatch("loadImageMetadataForAllExams").finally(() => {
    let exams = getters.selectedExams;
    if (!exams || !exams.length) exams = getters.exams;
    let images = [];
    exams.forEach(e => 
    {
      images.push.apply(images, getsortedImages(getters.imagesByExSrNo(e.exSrNo), getters.imagesOrderByExSrNo(e.exSrNo)))
    });
    let context = new PatientExamMultiviewContext(exams, images);
    context.constructFilters();
    commit("setPatientExamMultiviewContext", context);
    commit("addToBrowserStack", context);
    let elapsed = Date.now() - beforeLoad;
    logDetailed("actions", "openMultiview", "execution-time", "whole procedure", elapsed);
    return dispatch("loadImagesForMultiview");
  });
};

export const selectEyeMultiview = ({ commit, dispatch }, eye) => {
  commit("selectEyeMultiview", eye);
  return dispatch("loadImagesForMultiview");
};

export const selectDevicesMultiview = ({ commit, dispatch }, devices) => {
  commit("selectDevicesMultiview", devices);
  return dispatch("loadImagesForMultiview");
};

export const selectAllDevicesMultiview = ({ commit, dispatch }) => {
  commit("selectAllDevicesMultiview");
  return dispatch("loadImagesForMultiview");
};

export const selectDatesMultiview = ({ commit, dispatch }, dates) => {
  commit("selectDatesMultiview", dates);
  return dispatch("loadImagesForMultiview");
};

export const selectAllDatesMultiview = ({ commit, dispatch }) => {
  commit("selectAllDatesMultiview");
  return dispatch("loadImagesForMultiview");
};

export const selectAllExamsMultiview = ({ commit }) => {
  commit("selectAllExamsMultiview");
};

export const selectExamsMultiview = ({ commit }, exams) => {
  commit("selectExamsMultiview", exams);
};

export const closeMultiview = ({ commit, dispatch }) => {
  commit("clearPatientExamMultiviewContext");
  commit("setOriginalOverlaySettings", null);
  commit("clearImageQueue", "imageQueue");
  dispatch("popBrowserStack");
};

export const refreshMultiview = ({ commit, dispatch, getters }) => {
  let action = getters.emrProSearchParams && getters.emrProExSrNo ? "getPatientExamSSO" : "getPatientExams"
  return dispatch(action)
    .then(() => {
      let exams = getters.selectedExams;
      if (!exams || !exams.length) exams = getters.exams;
    commit("refreshMultiview", exams);
      commit("clearImageOrder");
      return dispatch("loadImageMetadataForAllExams", { forceLoad: true })
    }).then(() => dispatch("resetMultiviewImages"));
};

export const updateCurrentExamsMultiview = ({ dispatch, commit }, bounds) => {
  commit("setCurrentExamsMultiview", bounds);
  return dispatch("loadImagesForMultiview");
}

export const resetMultiviewImages = ({ dispatch, getters, commit }) => {
  let exams = getters.selectedExams;
  if (!exams || !exams.length) exams = getters.exams;
  let images = [];
  exams.forEach(e => 
  {
    images.push.apply(images, getsortedImages(getters.imagesByExSrNo(e.exSrNo), getters.imagesOrderByExSrNo(e.exSrNo)))
  });
  commit("resetMultiviewImages", { exams, images });
  return dispatch("loadImagesForMultiview");
}

export const loadImagesForMultiview = ({ dispatch, getters }) =>
  dispatch("loadImages_thumb", getters.currentMultiviewImages);